import React, { Component } from 'react';



class travel extends Component {

    render() {
        
        return (
            <section>

            <section className="container section" id="tabs">
            <div className="scrollspy" id="top">
            <div className="row">
            <div className="col s12 m12 l12 center">
            <ul className="tabs">
                    <li className="tab">
                    <a href="#picsChina" className=" indigo-text text-darken-4">China</a>
                    </li>
                    <li className="tab">
                    <a href="#picsCanada" className="indigo-text text-darken-4">Canada</a>
                    </li>
                    <li className="tab">
                    <a href="#picsUSA" className="indigo-text text-darken-4">USA</a>
                    </li>
                    <li className="tab">
                    <a href="#picsMaldives" className="active indigo-text text-darken-4">Maldives</a>
                    </li>
                    <li className="tab">
                    <a href="#picsEurope" className="indigo-text text-darken-4">Europe</a>
                    </li>
                    <li className="tab">
                    <a href="#picsMexico" className="indigo-text text-darken-4">Mexico</a>
                    </li>
                    <li className="tab">
                    <a href="#picsBahamas" className="indigo-text text-darken-4">Bahamas</a>
                    </li>
                    <li className="tab">
                    <a href="#picsHonduras" className="indigo-text text-darken-4">Honduras</a>
                    </li>
                    <li className="tab">
                    <a href="#picsThailand" className="indigo-text text-darken-4">Thailand</a>
                    </li>
                    <li className="tab">
                    <a href="#picsMalaysia" className="indigo-text text-darken-4">Malaysia</a>
                    </li>
                    <li className="tab">
                    <a href="#picsKorea" className="indigo-text text-darken-4">Korea</a>
                    </li>
                    <li className="tab">
                    <a href="#picsJapan" className="indigo-text text-darken-4">Japan</a>
                    </li>
            </ul>
            </div>
            </div>
            </div>

            <section className="container section" id="picsChina">
            <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/1.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Performing Arts Centre</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/2.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Beihai Park</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/3.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Modernista</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/4.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Prince Gong Mansion</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>


        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/5.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Prince Gong Mansion</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/6.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">National Library</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/7.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Siji Minfu Roast Duck</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/8.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Siji Minfu Roast Duck</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/9.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Siji Minfu Roast Duck</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/10.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Siji Minfu Roast Duck</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/11.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Siji Minfu Roast Duck</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/12.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">National Museum</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/13.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Chong Qing</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/14.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Panda Center</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/15.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Yungang Grottoes</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/16.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Huang Long</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/17.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Jiuzhai Valley - Long Sea</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/18.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Multicolored pool</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/19.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Panda sea</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/20.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Pearl Beach Waterfall</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/21.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Terracotta Army</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/22.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Da-Yan Tower fountain</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/23.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Songzanlin Temple</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/24.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Lamuyangcuo Lake</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/25.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Lamuyangcuo Lake</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/26.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Napa Sea</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/27.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Dukezong Ancient City</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/28.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Tiger Leaping Gorge</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/29.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Lugu Lake</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/30.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Erhai Lake</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/31.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Botanical Garden</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/32.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Jinma Biji Fang</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>


        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/33.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Jiuxiang Scenic Area</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/34.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Jiuxiang Scenic Area</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/35.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Stone Forest</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/36.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Manting Park</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/37.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Jinci Temple</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/38.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Wang Family Courtyard</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/39.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Hanging Temple</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/40.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Huayan Temple</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/41.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Daming Lake</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/42.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Ji Nan</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/43.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Baotu Spring</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/44.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Jiuzhangya Park</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/45.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Shen Yang 918</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/46.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Changbai mountain pool</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/47.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Dalian Discoveryland</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/48.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">The Tientsin Eye</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/49.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Lion Forest Garden</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/50.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">West Lake</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/51.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Wu Zhen ancient town</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img3/52.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Shang Hai</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

            </section>

            <section className="container section" id="picsCanada">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/36.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/35.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/34.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/33.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/32.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/31.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/30.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/29.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/28.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/27.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/26.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/25.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/1.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">CN Tower</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/2.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">High Park</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/3.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Hign Park</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/4.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Niagara Falls</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>


        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/5.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Wonderland</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/6.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Wonderland</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/7.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Wonderland</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/8.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Woodbine</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/9.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Woodbine</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/10.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Art Gallery</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/11.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">City Hall</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/12.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Royal Museum</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>


        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/13.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Toronto Zoo</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/14.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Centre Island</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/15.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Eaton Centre</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/16.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Mont Royal</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/17.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Notre-Dame</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/18.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Maple Tree Sq.</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/19.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">China Town</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/20.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Stanley Park</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>


        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/21.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">English Bay</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/22.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Canada Place</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/23.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">uOttawa</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/24.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Parliament Hill</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/25.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Parliament Hill</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/26.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">ByWard</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/27.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Notre-Dame</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/28.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">NationalGallery</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>


        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/29.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Commissioners</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/30.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Parc Omega</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/31.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Thousand Islands</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img5/32.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Old Quebec</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

            </section>

            <section className="container section" id="picsUSA">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/15.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/112.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/22.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/11.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/24.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/23.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/110.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/21.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/20.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/19.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/18.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/17.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/16.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/109.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/14.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/13.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/12.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/111.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/10.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/9.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/8.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/7.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/6.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/5.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/4.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/3.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/2.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/1.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col s12 m6 l3">
                <div className="card">
                <div className="card-image">
                    <img src="../img6/5.png" alt="" className="responsive-img materialboxed"/>
                </div>
                </div>
            </div>

            <div className="col s12 m6 l3">
                <div className="card">
                <div className="card-image">
                    <img src="../img6/8.png" alt="" className="responsive-img materialboxed"/>
                </div>
                </div>
            </div>

            <div className="col s12 m6 l3">
                <div className="card">
                <div className="card-image">
                    <img src="../img6/4.png" alt="" className="responsive-img materialboxed"/>
                </div>
                </div>
            </div>

            <div className="col s12 m6 l3">
                <div className="card">
                <div className="card-image">
                    <img src="../img6/1.png" alt="" className="responsive-img materialboxed"/>
                </div>
                </div>
            </div>
            </div>
                </section>
                
            <section className="container section" id="picsEurope">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/108.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/107.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/106.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/105.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/104.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/103.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/102.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/101.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/100.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/99.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/98.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/97.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/96.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/95.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/94.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/93.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/92.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/91.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/90.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/89.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            </section>    

            <section className="container section" id="picsMaldives">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/56.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/55.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/54.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/53.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/52.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/51.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/50.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/49.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/48.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/47.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/46.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/45.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/44.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/43.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/42.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/41.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/40.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/39.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/38.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/37.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            
            </section> 

            <section className="container section" id="picsMexico">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/88.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/87.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/86.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/85.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            </section>    

            <section className="container section" id="picsBahamas">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/84.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/83.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/82.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/81.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            </section> 

            <section className="container section" id="picsHonduras">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/60.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/59.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/58.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/57.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            </section> 

            <section className="container section" id="picsThailand">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/64.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/63.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/62.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/61.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/1.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Coral Island</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/2.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Racha Island</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/3.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Kata Beach</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/4.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Prom Thep Cape</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>


        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/5.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Prom Thep Cape</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/6.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Maya Bay</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/7.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Coral Island</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/8.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Karon Beach</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/9.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Maya Bay</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/10.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Pa Tong Beach</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/11.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Chiang Mai night market</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/12.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Zipline adventures</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/13.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Nimmanhaemin Road</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/14.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Chiang Mai Night Safari</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/15.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Chiang Mai Night Safari</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img4/16.png" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Bangkok SIAM</span>
                {/* <a href="" className="halfway-fab btn-floating pink pulse"> */}
                {/* <i className="material-icons">favorite</i> */}
                {/* </a> */}
            </div>
            {/* <div className="card-content">
                <span className="card-title">Canada</span>
                <p>Toronto</p>
                <br/>
                <p className="right grey-text">Upload Date: 2016-12-05</p>
            </div>
            <div className="card-action">
            <a href="/travelNoteToronto">View travel notes</a>
            </div> */}
            </div>
        </div>
        </div>

            </section>

            <section className="container section" id="picsMalaysia">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/72.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/71.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/70.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/69.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/68.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/67.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/66.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/65.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            </section> 

            <section className="container section" id="picsKorea">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/76.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/75.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/74.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/73.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            </section> 

            <section className="container section" id="picsJapan">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/80.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/79.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/78.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../travelPics/77.JPG" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            </section> 

            <a href="#top" className="ToTheTopIcon">
                <i className="material-icons">arrow_upward</i>
            </a>

        </section>
        
        </section>

        )
    }
}




export default travel;